import {createAction} from 'web-app/util/redux/famly-app-helpers';

const domain = 'MANAGE_GROUPS';

export const {
    action: createGroup,
    success: createGroupSuccess,
    failed: createGroupFailed,
} = createAction(`${domain}/CREATE_GROUP`, (institutionId, title) => ({institutionId, title}));
